import { DocumentRequestComponent } from './document-request.component';
export var documentRequestRoutes = [
    {
        path: 'document-request',
        component: DocumentRequestComponent,
        data: {
            'expectedRoles': ['Admin', 'Accountant Admin', 'Accountant']
        },
    }
];
var DocumentRequestRoutingModule = (function () {
    function DocumentRequestRoutingModule() {
    }
    return DocumentRequestRoutingModule;
}());
export { DocumentRequestRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request/document-request-routing.module.ts.pre-build-optimizer.js